import dayjs from 'dayjs';

const isBusinessClosedInPreviousYear = (businessInfo) => {
  const currentYear = dayjs(new Date()).year();
  return (
    businessInfo.busStatus === 'closed' &&
    businessInfo.dateBusClosed &&
    dayjs(businessInfo.dateBusClosed).year() < currentYear
  );
};

const isBusinessSoldInPreviousYear = (businessInfo) => {
  const currentYear = dayjs(new Date()).year();
  return (
    businessInfo.busStatus === 'sold' &&
    businessInfo.dateBusSold &&
    dayjs(businessInfo.dateBusSold).year() < currentYear
  );
};

const shouldBypassItemization = (
  { isFirstTimeFiler, bypassItemization },
  { busStatus, dateBusSold }
) => {
  const isBusClosedInPrevYear = isBusinessClosedInPreviousYear({ busStatus, dateBusSold });
  const isBusSoldInPrevYear = isBusinessSoldInPreviousYear({ busStatus, dateBusSold });
  return (
    (isBusClosedInPrevYear || isBusSoldInPrevYear) && !isFirstTimeFiler && bypassItemization !== 'Y'
  );
};
export default shouldBypassItemization;
